import React, { Dispatch, SetStateAction, useState } from "react";
import { Link } from "react-router-dom";
import { navtype } from "../../../interface/interface";
import { ReactComponent as NewSvg } from "../svg/new.svg";
function NavBox({
  category,
  img,
  nav,
  path,
  isOpen,
  setIsOpen,
  idx,
}: {
  category: string;
  img: string;
  nav: Array<navtype>;
  path: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<number | undefined>>;
  idx: number;
}) {
  return (
    <div
      className={`nav-box ${isOpen ? "open" : ""}`}
      style={
        isOpen
          ? {
              height: `${(nav.length + 2) * 34}px`,
            }
          : undefined
      }
    >
      <button
        className="title-btn"
        onClick={() => {
          if (!isOpen) {
            setIsOpen(idx);
          } else {
            setIsOpen(undefined);
          }
        }}
      >
        <div className="left">
          <img src={`/assets/sidebar${img}.svg`} alt="" />
          <div className="title">{category}</div>
        </div>
        <img src="/assets/sidebar/arrow.svg" alt="" className="arrow" />
      </button>
      <div className="nav-wrapper">
        {nav.map(({ title, link, type }, idx) => {
          return type !== "new" ? (
            <Link
              to={link}
              key={idx}
              className={`nav-link ${path === link ? "link-active" : ""}`}
            >
              {title}
            </Link>
          ) : (
            <Link
              to={link}
              key={idx}
              className={`new-link ${path === link ? "new-active" : ""}`}
            >
              <NewSvg />
              <div className="title">{title}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default NavBox;
